import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "@fce-bees/fce-common-components/styles.css";
import "./styles/theme-variables.scss";
import "./index.css";
import { asyncWithFbProvider } from "@featbit/react-client-sdk";

if (import.meta.env.VITE_MOCKS_ENABLED === "true") {
    import("msw/browser").then(async ({ setupWorker }) => {
        const { handlers } = await import("./mocks/handlers");

        const worker = setupWorker(...handlers);
        worker.start({ quiet: true }).then((registration) => {
            if (!!registration && !!registration.active) {
                console.log("Mock Service Worker: " + registration.active.state);
            }
        });
    });
}

const prequalAppContainer = document.querySelector(".prequal_54873");

if (prequalAppContainer) {
    const featBitSdkKey = import.meta.env.VITE_REACT_APP_FEATBIT_SDK_KEY;

    if (featBitSdkKey) {
        const featBitOptions = {
            options: {
                sdkKey: featBitSdkKey,
                streamingUri: import.meta.env.VITE_REACT_APP_FEATBIT_STREAMING_URL,
                eventsUri: import.meta.env.VITE_REACT_APP_FEATBIT_EVENT_URL,
                user: {
                    name: "anonymous",
                    keyId: "anonymous",
                    customizedProperties: [],
                },
            },
        };
        const FeatBitProvider = await asyncWithFbProvider(featBitOptions);

        createRoot(prequalAppContainer).render(
            <StrictMode>
                <FeatBitProvider>
                    <App />
                </FeatBitProvider>
            </StrictMode>
        );
    } else {
        createRoot(prequalAppContainer).render(
            <StrictMode>
                <App />
            </StrictMode>
        );
    }
} else {
    console.error(
        "Prequal application mount point not found. An element with class 'prequal_54873' must exist on the page."
    );
}
